import axios from '@/plugins/axios'
import { MessageBox } from "element-ui"

export default {
    namespaced: true,

    state: {
        trackStatus: 2,
        loading: false,
        currentPage: 1,
        pageSize: 10,
        tracks: [],
        track: { album: { legal: {} } },
        assets: {},
        showDialog: false,
        duplicates: []
    },

    mutations: {
        setTrackStatus(state, status) {
            state.trackStatus = status
        },

        setLoading(state, bool) {
            state.loading = bool
        },

        setCurrentPage(state, page) {
            state.currentPage = page
        },

        setPageSize(state, size) {
            state.pageSize = size
        },

        setTracks(state, tracks) {
            state.tracks = tracks
        },

        setDuplicates(state, duplicates) {
            state.duplicates = duplicates
        },

        setAssets(state, assets) {
            state.assets = assets
        },

        setShowDialog(state, bool) {
            state.showDialog = bool
        },

        setTrack(state, track) {
            state.track = track
        }
    },

    getters: {
        getColumns(state) {
            const columns = {
                '1': ['cover', 'created_at', 'account', 'format', 'tracks', 'title', 'artist', 'isrc', 'upc'],
                '2': [
                    'cover', 'created_at', 'account', 'format', 'tracks', 'title', 'artist', 'isrc', 'upc', 'status',
                    'actions', 'checkbox', 'distro'
                ],
                '3': [
                    'cover', 'created_at', 'account', 'format', 'tracks', 'title', 'artist', 'isrc', 'upc', 'status',
                    'actions', 'checkbox', 'distro'
                ],
                '4': ['cover', 'created_at', 'account', 'format', 'tracks', 'title', 'artist', 'isrc', 'upc', 'status'],
                '5': ['cover', 'created_at', 'account', 'format', 'tracks', 'title', 'artist', 'isrc', 'upc', 'status']
            }
            return columns[state.trackStatus]
        },

        getActions(state) {
            const actions = {
                '2': ['status', 'publish', 'edit', 'delete', 'download', 'distro','unpublish'],
                '3': ['takedown', 'status']
            }
            return actions[state.trackStatus] || []
        }
    },

    actions: {
        async getTracks({ commit, state }, { publish = false } = {}) {
            try {
                commit('setLoading', true)
                const { data } = await axios.admin.get(
                    `distro?status=${state.trackStatus}&limit=${state.pageSize}&page=${state.currentPage}&publish=${publish}`
                )
                commit('setTracks', data)
            } catch (err) {
                console.error(err)
            } finally {
                commit('setLoading', false)
            }
        },

        async duplicates({ dispatch, commit }, track) {
            try {
                const { data } = await axios.admin.get(`distro/duplicates/${track.id}`)
                commit('setDuplicates', data)
            } catch (err) {
                console.error(err)
            }
        },

        async update({ dispatch, commit }, track) {
            try {
                await axios.admin.put(`distro/${track.id}`,  track)
                dispatch('getTracks')
                commit('setShowDialog', false)
            } catch (err) {
                console.error(err)
            }
        },

        async deleteTrack({ dispatch }, id) {
            try {
                await MessageBox.confirm('Do you really want to delete this track?',
                    'Delete Track', {
                        confirmButtonText: 'Yes', cancelButtonText: 'No', type: 'warning'
                    })
                await axios.admin.delete(`distro/${id}`)
                dispatch('getTracks')
            } catch (err) {
                console.error(err)
            }
        },

        async changeStatus({ dispatch }, data) {
            try {
                await axios.admin.post(`distro/status/${data.trackId}`, { status: data.status })
                dispatch('getTracks')
            } catch (err) {
                console.error(err)
            }
        },

        async bulkChangeStatus({ dispatch }, data) {
            try {
                await axios.admin.post(`distro/status`, { ids: data.ids, status: data.status })
                dispatch('getTracks')
            } catch (err) {
                console.error(err)
            }
        },

        async sendToDistro({ state, dispatch }, tracks) {
            try {
                await axios.admin.post('distro/send-to-distro', { ids: tracks })
                dispatch('getTracks')
            } catch (err) {
                console.error(err)
            }
        },

        async publish({ state, dispatch }, tracks) {
            try {
                await axios.admin.post('distro/publish', { ids: tracks })
                dispatch('getTracks')
            } catch (err) {
                console.error(err)
            }
        },

        async unpublish({ state, dispatch }, track) {
            try {
                await axios.admin.post('distro/unpublish', { id: track })
                dispatch('getTracks', { publish: true })
            } catch (err) {
                console.error(err)
            }
        },

        async download({ state }, tracks) {
            try {
                const response = await axios.admin.get(`distro/download?ids=${tracks}`, {
                    responseType: "arraybuffer"
                })

                if (response) {
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')

                    link.href = url;
                    link.setAttribute('download', 'distro-tracks.zip')

                    document.body.appendChild(link);
                    link.click();
                }
            } catch (err) {
                console.error(err)
            }
        },

        async staticAssets({ commit }) {
            try {
                const { data } = await axios.admin.get('/distro/static-assets')
                commit('setAssets', data)
            } catch (err) {
                console.error(err)
            }
        }
    }
}